// extracted by mini-css-extract-plugin
export var actionText = "_rl-4";
export var container = "_rl-0";
export var leftSection = "_rl-1";
export var rightSection = "_rl-2";
export var settingsButton = "_rl-6";
export var settingsIcon = "_rl-7";
export var shortcut = "_rl-5";
export var shortcutGroup = "_rl-3";